package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class ConvertToWalmartAccountWithSetupCodeRequestInfo(
    @SerialName("setupCode") val setupCode: String,
    @SerialName("vzAuthCode") val vzAuthCode: String
)